export const DataGridStyle = {
    maxHeight: '100vh',
    margin: '20px 10px',
    '& .header': {
        backgroundColor: 'primary.main',
        color: '#ffffff',
    },
    //Hace el wrap del texto en el header
    '& .MuiDataGrid-columnHeaderTitle': {
        whiteSpace: 'normal',
        lineHeight: 'normal',
        textAlign: 'center',
    },
    '.MuiDataGrid-columnHeaderTitleContainer': {
        justifyContent: 'center',
        alignItems: 'center',
        whiteSpace: 'normal',
        wordWrap: 'normal',
        borderBottom: 'transparent',
    },
    '& .MuiDataGrid-columnsContainer': {
        border: '1px solid',
    },
    '& .MuiDataGrid-columnHeader': {
        borderRight: '1px solid #ffffff',
    },
    '& .MuiDataGrid-cell': {
        whiteSpace: 'nowrap',
        wordWrap: 'normal',
        borderBottom: `1px solid #0B3E83`,
        borderRight: `1px solid #0B3E83`,
    },
    '& .MuiDataGrid-row:hover': {
        backgroundColor: 'rowShadow.main',
    },
};
